import React, { useState, useEffect } from "react";
import { FiEye } from "react-icons/fi";
import FileUpload from "../../../ResuableCompoment/FileUpload";

const UploadDocument = ({ onUpdate, data = {} }) => {
  const [formData, setFormData] = useState({
    aadhaarFront: null,
    aadhaarBack: null,
    panCard: null,
    shopPhoto: null,
    selfieWithSalesPerson: null,
    selfieWithDocuments: null,
    signaturePhoto: null,
    passbookOrChequeBook: null,
    gstcertificate: null,
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (data) {
      setFormData((prev) => ({
        ...prev,
        ...data,
      }));
    }
  }, [data]);

  const allowedExtensions = ["jpg", "jpeg", "png", "gif"];
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB


  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (!files || files.length === 0) return;

    const file = files[0];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    const isValidExtension = allowedExtensions.includes(fileExtension);
    const isValidSize = file.size <= MAX_FILE_SIZE;

    const isValidFile = isValidExtension && isValidSize;

    const updatedFormData = {
      ...formData,
      [name]: isValidFile ? file : null,
    };

    setFormData(updatedFormData);
    onUpdate(updatedFormData);

    setErrors((prev) => ({
      ...prev,
      [name]: isValidFile ? "" : "Only image files are allowed and lest than 5MB!",
    }));
  };

  return (
    <div className="w-full">

      {/* Section Title */}
      <h3 className="text-lg font-semibold text-[#0A2A4F] mb-6 text-center">
        Merchant Upload Documents
      </h3>

      {/* Upload Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 min-h-[380px]">
        {Object.entries(formData).map(([key, file]) => {
          const hasError = errors[key];

          return (
            <div
              key={key}
              className={`
                relative rounded-lg p-3
                border
                ${hasError
                  ? "border-red-400 bg-red-50"
                  : file
                    ? "border-[#0A2A4F] bg-slate-50"
                    : "border-slate-200 bg-white"
                }
              `}
            >
              <FileUpload
                label={`${key
                  .replace(/([A-Z])/g, " $1")
                  .replace(/^./, (str) => str.toUpperCase())
                  .trim()}*`}
                name={key}
                value={file}
                onChange={handleFileChange}
              />

              {/* Preview Icon */}
              {file && !hasError && (
                <a
                  href={typeof file === "string" ? file : URL.createObjectURL(file)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="absolute top-3 right-3 text-[#0A2A4F] hover:opacity-80"
                >
                  <FiEye size={18} />
                </a>
              )}

              {/* Error */}
              {hasError && (
                <p className="text-red-600 text-xs mt-1">
                  {hasError}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UploadDocument;
